<div class="pnf-module">
  <div class="texture noselect" translate>page-not-found</div>
  <div class="cover-container">
    <img src="../../assets/imgs/background_fog.png" alt="" class="cover">
  </div>
</div>